import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c59e2ab")

_pushScopeId("data-v-5c59e2ab")
const _hoisted_1 = { class: "software_mask" }
const _hoisted_2 = { class: "software_box" }
const _hoisted_3 = { class: "software_head flex_space_center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "可牛软件", -1)
const _hoisted_5 = { class: "software_content flex_start_center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 是否安装？ ")
const _hoisted_8 = { class: "software_bottom flex_end_center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("i", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
        })
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("img", {
          src: _ctx.viewModel.modalIcon,
          alt: ""
        }, null, 8, ["src"]),
        _createVNode("div", null, [
          _createTextVNode(" 使用该功能需要安装“" + _toDisplayString(_ctx.viewModel.title) + "” ", 1),
          _hoisted_6,
          _hoisted_7
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("span", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
        }, "取消"),
        _createVNode("span", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSuccess && _ctx.onSuccess(...args)))
        }, "确定")
      ])
    ])
  ]))
})